import { jsx as _jsx } from "react/jsx-runtime";
import InformationFilled16 from '@carbon/icons-react/es/information--filled/16';
import styled from 'styled-components';
const Wrapper = styled.div`
  color: ${({ color })=>color !== null && color !== void 0 ? color : 'var(--blue-50)'};
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const InformationIcon = ({ color = 'var(--blue-50)' })=>{
    return /*#__PURE__*/ _jsx(Wrapper, {
        color: color,
        children: /*#__PURE__*/ _jsx(InformationFilled16, {})
    });
};
